import { defineTransform } from '@client/core/data/concerns/parses-from-json/transform-map';

/**
 * High-level summary of all Risks related to a Project.
 * @see app/Http/Resources/Project/ProjectRisksSummaryResource.php
 */
export class ProjectRisksSummary {
  constructor(public readonly total: number) {}
}

defineTransform(ProjectRisksSummary, (json, { fromSnakeCaseKeys }) => {
  return fromSnakeCaseKeys();
});
